import { useApiClient } from "@/modules/api/apiClient.store.ts";
import { getPaymentTarget, PaymentResult, type PaymentProps } from "@/modules/billing/payment/PaymentParams.ts";
import { creditBuyRequest } from "@/modules/billing/payment/paymentUtils.ts";
import { getPaypalSessionId } from "@/modules/billing/paypal/utils.ts";
import { t_StartingPayment } from "@/modules/billing/progressLabels.tsx";
import type { PaypalVaultConfig, PaypalVaultCreditBuyBody } from "@warrenio/api-spec/spec.oats.gen";
import { useImperativeHandle } from "react";

export default function PaypalVaultPaymentForm({ actionsRef }: PaymentProps & { config: PaypalVaultConfig }) {
    const apiClient = useApiClient();

    useImperativeHandle(actionsRef, () => ({
        needsPopUp(_params) {
            return false;
        },
        async makePayment(params) {
            const { getCard, progress, account } = params;

            progress(t_StartingPayment);
            const buyResult = await creditBuyRequest<PaypalVaultCreditBuyBody>(apiClient, {
                billing_account_id: account.id,
                payment_object_id: getCard().id,
                ...getPaymentTarget(params),
                session_id: getPaypalSessionId(),
                on_session: false,
            });

            if (buyResult.success) {
                return PaymentResult.SUCCESS;
            }

            return PaymentResult.VALIDATION_FAILED;
        },
    }));

    return null;
}
